<template>
  <div>
    <h1
      v-if="isPage"
      class="title"
    >
      {{ service.label }}
    </h1>
    <div v-if="categoryObj">
      <div class="field">
        <label class="label">{{ $t('common.category') }}</label>
        <div class="control">
          <span>{{ categoryObj.label }}</span>
          <span
            v-if="postCount != null"
            class="number-span"
          >
            <span class="mr-1 is-size-7">{{ $t('common.count') }}:</span>
            <span>{{ postCount }}</span>
          </span>
        </div>
      </div>
    </div>
    <b-field
      v-else
      :label="$t('common.category')"
      :type="checkEmpty(errors.category) ? '' : 'is-danger'"
      :message="checkEmpty(errors.category) ? '' : errors.category[0]"
      :class="{ 'mt-6': isPage }"
    >
      <category-select
        v-model="category"
        :count="category ? postCount : null"
      ></category-select>
    </b-field>
    <!--
    <div v-if="category">{{ postCount }}件</div>
    -->

    <b-field
      v-if="drillMode === 'count'"
      :label="$t('common.countOf', { target: $t('term.question') })"
      :type="checkEmpty(errors) ? '' : 'is-danger'"
      :message="checkEmpty(errors) ? '' : errors[0]"
      class="mt-6"
      grouped
    >
      <b-input
        v-model="count"
        @blur="validateCount()"
      ></b-input>
      <p class="control">{{ $t('common.questionUnit') }}</p>
    </b-field>

    <b-field
      v-else
      :label="$t('term.spentTime')"
      :type="checkEmpty(errors) ? '' : 'is-danger'"
      :message="checkEmpty(errors) ? '' : errors[0]"
      class="mt-6"
      grouped
    >
      <b-input
        v-model="drillTimeMin"
        @blur="validateDrillTimeMin()"
      ></b-input>
      <p class="control">{{ $t('common.minutes') }}</p>
    </b-field>

    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="isIncludeMastered"
          />
          {{ $t('term.includeMasteredPost') }}
        </label>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="isStartFromFirst"
          />
          {{ $t('term.startFromFirst') }}
        </label>
      </div>
    </div>

    <div class="block mt-6">
      <button
        @click="start()"
        :disabled="errors.length > 0 || !count || !category"
        class="button is-medium is-fullwidth is-info"
      >
        <span class="icon">
          <i class="far fa-play-circle"></i>
        </span>
        <span>{{ $t('common.start') }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { Service, Post, User, Category } from '@/api'
import CategorySelect from '@/components/molecules/CategorySelect'
import utilDate from '@/util/date'

export default {
  name: 'PostStart',

  components: {
    CategorySelect,
  },

  props: {
    isPage: {
      type: Boolean,
      default: false,
    },

    categorySlug: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      service: [],
      drillTimeMin: '',
      category: '',
      categoryObj: null,
      count: 1,
      errors: [],
      drillMode: 'count', // enums: count / time
      isIncludeMastered: false,
      isStartFromFirst: false,
      postCount: 0,
    }
  },

  computed: {
    drillTimeSec() {
      return this.drillTimeMin * 60
    },
  },

  watch: {
    category() {
      this.setPostCount()
    },

    isIncludeMastered() {
      if (!this.category) return
      this.setPostCount()
    },
  },

  async created() {
    await this.setService()
    if (this.categorySlug) {
      this.category = this.categorySlug
      await this.setCategoryObj(this.categorySlug)
    }
  },

  methods: {
    async setService() {
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Service.get(this.serviceId)
        this.$store.dispatch('setLoading', false)
        this.service = res
      } catch (err) {
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setPostCount() {
      if (this.isIncludeMastered) {
        await this.setPostCountByCategory()
      } else {
        await this.setPostCountExcludedMastered()
      }
    },

    async setPostCountExcludedMastered() {
      this.$store.dispatch('setLoading', true)
      try {
        const params = {
          serviceId: this.serviceId,
          category: this.category,
        }
        this.postCount = await User.getDrillsCount(params, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setPostCountByCategory() {
      this.$store.dispatch('setLoading', true)
      try {
        const params = { category: this.category }
        this.postCount = await Post.getCount(this.serviceId, params)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setCategoryObj(categorySlug) {
      this.$store.dispatch('setLoading', true)
      try {
        const params = {}
        const res = await Category.get(this.serviceId, categorySlug)
        this.categoryObj = res.item
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async start() {
      if (this.drillMode === 'count') {
        await this.startByCount()
      } else {
        await this.startByTime()
      }
    },

    async startByCount() {
      this.$store.dispatch('setLoading', true)
      let drill
      try {
        const vals = {
          serviceId: this.serviceId,
          category: this.category,
          count: this.count,
          includeMastered: this.isIncludeMastered,
          isStartFromFirst: this.isStartFromFirst,
        }
        drill = await User.startDrill(vals, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
        return
      }

      this.$store.dispatch('prepareLearning', {
        drillId: drill.drillId,
        userAnswers: drill.userAnswers,
      })

      const nextAnswer = drill.userAnswers[0]
      this.$store.dispatch('setLearningCurrentAnswerId', nextAnswer.userAnswerId)
      this.$router.push(`/posts/${nextAnswer.serviceId}/${nextAnswer.postSlug}`)
    },

    async startByTime() {
      this.$store.dispatch('setLoading', true)
      let drill
      try {
        const vals = {
          serviceId: this.serviceId,
          drillTime: this.drillTimeSec,
        }
        drill = await User.startDrill(vals, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
        return
      }

      const endTime = utilDate.unixtimeFromStr(drill.startedAt) + this.drillTimeSec
      this.$store.dispatch('startLearning', {
        drillId: drill.drillId,
        endTime: endTime,
        userAnswers: drill.userAnswers,
      })

      const nextAnswer = drill.userAnswers[0]
      this.$store.dispatch('setLearningCurrentAnswerId', nextAnswer.userAnswerId)
      this.$router.push(`/posts/${nextAnswer.serviceId}/${nextAnswer.postSlug}`)
    },

    validateCount() {
      this.errors = []
      // this.count = this.count.trim()
      if (!this.count) {
        this.errors.push(this.$t('msg["Input required"]'))
        return
      }
      if (isNaN(this.count) === true) {
        this.errors.push(this.$t('msg.InvalidInput'))
        return
      }
      // this.count = Number(this.count.trim())
    },

    validateDrillTimeMin() {
      this.errors = []
      this.drillTimeMin = this.drillTimeMin.trim()
      if (!this.drillTimeMin) {
        this.errors.push(this.$t('msg["Input required"]'))
        return
      }
      if (isNaN(this.drillTimeMin) === true) {
        this.errors.push(this.$t('msg.InvalidInput'))
        return
      }
      this.drillTimeMin = Number(this.drillTimeMin.trim())
    },
  },
}
</script>

<style scoped>
.control {
  padding-top: 10px;
}
</style>
